import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Card, CardContent, Grid, Button, Chip } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DescriptionIcon from '@mui/icons-material/Description';
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import axios from '../api/axios';
import DecorativeCubes from '../components/DecorativeCubes';

const DocumentsPage = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = {
    all: 'Все',
    regulations: 'Нормативные документы',
    orders: 'Приказы',
    reports: 'Отчеты',
    forms: 'Формы',
    other: 'Другое',
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    try {
      const response = await axios.get('/documents/public');
      setDocuments(response.data);
    } catch (error) {
      console.error('Error fetching documents:', error);
    } finally {
      setLoading(false);
    }
  };

  const getFileIcon = (fileType) => {
    if (fileType === 'pdf') return <PictureAsPdfIcon />;
    if (['jpg', 'png'].includes(fileType)) return <ImageIcon />;
    if (fileType === 'link') return <DescriptionIcon />;
    return <InsertDriveFileIcon />;
  };

  const filteredDocuments =
    selectedCategory === 'all'
      ? documents
      : documents.filter((doc) => doc.category === selectedCategory);

  if (loading) {
    return (
      <>
        <Header />
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Typography variant="h5" align="center">
            Загрузка...
          </Typography>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <DecorativeCubes minCubes={7} maxCubes={11} />
      <Header />
      <Box sx={{ position: 'relative', minHeight: '100vh' }}>
        <DecorativeCubes minCubes={7} maxCubes={11} />
        <Container maxWidth="lg" sx={{ py: 8, position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <DescriptionIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography
              variant="h2"
              sx={{
                mb: 2,
                fontWeight: 700,
                color: 'primary.main',
              }}
            >
              Документы
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Нормативные документы консультационного центра
            </Typography>
          </Box>

        

        {filteredDocuments.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h6" color="text.secondary">
              Документы пока не добавлены
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {filteredDocuments.map((doc) => (
              <Grid item xs={12} md={6} key={doc._id}>
                <Card
                  sx={{
                    height: '100%',
                    borderRadius: 4,
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 6,
                    },
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                      <Box
                        sx={{
                          mr: 2,
                          color: 'primary.main',
                          fontSize: 40,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {getFileIcon(doc.fileType)}
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                          <Chip
                            label={categories[doc.category]}
                            size="small"
                            color="primary"
                            variant="outlined"
                          />
                          <Chip
                            label={doc.fileType.toUpperCase()}
                            size="small"
                            variant="outlined"
                          />
                        </Box>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                          {doc.title}
                        </Typography>
                        {doc.description && (
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            {doc.description}
                          </Typography>
                        )}
                        <Button
                          variant="outlined"
                          startIcon={doc.fileType === 'link' ? <DescriptionIcon /> : <DownloadIcon />}
                          size="small"
                          href={doc.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {doc.fileType === 'link' ? 'Открыть ссылку' : 'Скачать'}
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default DocumentsPage;
